import { configureStore } from "@reduxjs/toolkit";
import { currentUserReducer } from "@retro-ia/shared/auth";

export const store = configureStore({
  reducer: {
    currentUser: currentUserReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
